import { getById } from 'services/utils'
import { ProductPackage } from './../../api/entities/catalog/packages/common'
import { GenericChoiceTailored } from 'resources/catalog/packages/ProductPackageBaseFormContent'
import { required, minLength } from 'react-admin'

import { WithId } from 'types/common'
import { MainProductAPIEntity } from 'services/api/entities'
import { ServicesConfig } from 'services/api/entities/servicesconfig'
import { COLLECTION_NAME_SERVICE_MAP } from '../name-maps'
import { WithCustomerAndOrganizationIDS } from 'resources/catalog/packages/eventPackage/package/common'
import { isDefined } from './../index'

export const multipleOf = (x: number) => (v: number) =>
  v % x !== 0 ? `Value must be a multiple of ${x}` : undefined

export const validateText = [required(), minLength(1)]

export const validateUniqueById = (e?: (WithId | undefined)[]) => {
  if (!e) return undefined
  return e.length > new Set(e.filter(isDefined).map((i) => i?.id)).size
    ? 'You are trying to add the same item twice'
    : undefined
}
const isDefinedTyped = <T>(item: T | undefined): item is T => {
  return !!item
}

export const validateIsBundledPackage =
  (products: GenericChoiceTailored[]) =>
  (e?: (WithId | undefined)[], record?: ProductPackage) => {
    if (!e) return undefined

    const pkgPrivatesSelected = e
      .filter(isDefinedTyped)
      .map((p) => getById(products, p.id))
      .filter(isDefinedTyped)
      .filter((e) => !isPkgPublic(e))

    return !!pkgPrivatesSelected.length && record?.isBundledPackage === false
      ? 'You are trying to add a public package to a bundle'
      : undefined
  }

export const validateBudget = (budgetSpent?: number) => (value: number) => {
  if (!!budgetSpent && value < budgetSpent) {
    return `Budget should be greater than budget spent: ${budgetSpent}`
  }
  return undefined
}

export const validateBookingTimeLimit =
  (resource: MainProductAPIEntity, servicesConfig: ServicesConfig) =>
  (value: number) => {
    const { advanceReservationMin } =
      servicesConfig[COLLECTION_NAME_SERVICE_MAP[resource]]
    if (value && value < advanceReservationMin) {
      return `Please indicate a timelimit that is greater or equal than: ${advanceReservationMin}, the one set for the service`
    }
    return undefined
  }

export const isPkgPublic = (pkg: WithCustomerAndOrganizationIDS) =>
  !pkg.customers.length && !pkg.organizations.length

export const containsRelations = (
  pkg: WithCustomerAndOrganizationIDS,
  filter: WithCustomerAndOrganizationIDS
) => {
  return (
    filter.customers.every((c) => pkg.customers.includes(c)) &&
    filter.organizations.every((o) => pkg.organizations.includes(o))
  )
}
